import { mapToList } from '../../utils/transform';
import { types as actions } from '../actions';

const defaultState = {
  map: {},
  list: [],
  currentArea: {}
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.SET_CURRENT_AREA:
      return {
        ...state,
        currentArea: action.area
      };
    case actions.ADDED_ZONE: {
      let area = state.map[action.zone.site.id].find(
        item => item.id === action.zone.area.id
      );
      if (area) {
        area.zoneCount += 1;
      }
      let map = { ...state.map };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.ADDED_LOCATION: {
      let area = state.map[action.location.site.id].find(
        item => item.id === action.location.area.id
      );
      if (area) {
        area.locationCount += 1;
      }
      let map = { ...state.map };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.ADDED_AREA: {
      let areas =
        action.area.site.id in state.map ? state.map[action.area.site.id] : [];
      areas.push(action.area);
      let map = {
        ...state.map,
        [action.area.site.id]: areas
      };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.EDITED_AREA: {
      let areaId = action.area.id;
      let siteId = action.area.site.id;
      let areas = state.map[siteId].map(a=>{
        if(a.id === areaId){
          a.name = action.area.name; //only prop edited at the moment
        }
        return a;
      })
      let map = {
        ...state.map,
        [siteId]: areas
      };
      return {
        ...state,
        map,
        list: mapToList(map),
        currentArea: { ...state.currentArea }
      };
    }
    case actions.EXPANDED_AREA: {
      const siteId = action.area && action.area.site && action.area.site.id;
      let areas =
        siteId && siteId in state.map ? state.map[siteId] : [];
      let newAreas = areas.map(
        area => (area.id === action.area.id ? { ...action.area } : area)
      );
      let map = {
        ...state.map,
        [siteId]: [...newAreas]
      };
      return {
        ...state,
        map,
        list: mapToList(map),
        currentArea: { ...state.currentArea }
      };
    }
    case actions.GET_AREAS:
      return {
        ...defaultState,
      };
    case actions.SET_AREAS: {
      let map = {
        ...state.map,
        [action.siteId]: action.areas
      };
      return {
        ...state,
        map,
        list: mapToList(map)
      };
    }
    case actions.REMOVE_AREA: {
      let areaId = action.area.areaId;
      let siteId = action.area.siteId;
      let areas = state.map[siteId].filter(area => area.id !== areaId);
      let map = {
        ...state.map,
        [siteId]: areas
      };
      return {
        map,
        list: mapToList(map)
      };
    }
    case actions.EDIT_AREA_READY: 
      let editAreaZones = action.azones;
      return {
        ...state,
        editAreaZones
      }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/areas/index.js